/** The texts of a comment row; pass a part of it to translate. */
export interface NxCommentLabels {
  edit: string;
  delete: string;
  save: string;
  cancel: string;
  /** The resolve toggle while open. */
  resolve: string;
  /** The resolve toggle while resolved. */
  reopen: string;
  /** After the time of an edited comment. */
  edited: string;
  /** Badge of a resolved comment. */
  resolved: string;
  /** Title of the delete confirmation. */
  deleteTitle: string;
  deleteMessage: string;
  /** Under the inline editor. */
  editHint: string;
}

export const NX_COMMENT_LABELS: NxCommentLabels = {
  edit: 'Bearbeiten',
  delete: 'Löschen',
  save: 'Speichern',
  cancel: 'Abbrechen',
  resolve: 'Als erledigt markieren',
  reopen: 'Wieder öffnen',
  edited: 'bearbeitet',
  resolved: 'Erledigt',
  deleteTitle: 'Kommentar löschen?',
  deleteMessage: 'Der Kommentar wird endgültig entfernt.',
  editHint: 'Strg+Enter speichert · Esc bricht ab',
};
